/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_Expectlist_Vehiclesstrong2Inputs */

const id_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ Kendaraan`)
};

const ms_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ Kenderaan`)
};

const da_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ Køretøjer`)
};

const de_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ Fahrzeuge`)
};

const en_us2_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ Vehicles`)
};

const es_es2_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 100 vehículos`)
};

const es_mx2_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más de 100 vehículos`)
};

const fil_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ Sasakyan`)
};

const fr_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ véhicules`)
};

const it_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oltre 100 veicoli`)
};

const hu_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ jármű`)
};

const nl_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ voertuigen`)
};

const no_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ kjøretøy`)
};

const pl_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponad 100 pojazdów`)
};

const pt_br2_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de 100 veículos`)
};

const pt_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mais de 100 veículos`)
};

const ro_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peste 100 de vehicule`)
};

const fi_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yli 100 ajoneuvoa`)
};

const sv_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Över 100 fordon`)
};

const vi_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hơn 100 phương tiện`)
};

const tr_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ Araç`)
};

const cs_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ vozidel`)
};

const bg_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ превозни средства`)
};

const ru_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ транспортных средств`)
};

const uk_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ транспортів`)
};

const ar_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أكثر من 100 مركبة`)
};

const hi_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ वाहन`)
};

const th_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยานพาหนะมากกว่า 100 คัน`)
};

const ja_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100以上の乗り物`)
};

const zh_cn2_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ 载具`)
};

const zh_hant1_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100+ 載具`)
};

const ko_misc_posts_expectlist_vehiclesstrong2 = /** @type {(inputs: Misc_Posts_Expectlist_Vehiclesstrong2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`100개 이상의 탈것`)
};

/**
* | output |
* | --- |
* | "100+ Vehicles" |
*
* @param {Misc_Posts_Expectlist_Vehiclesstrong2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_expectlist_vehiclesstrong2 = /** @type {((inputs?: Misc_Posts_Expectlist_Vehiclesstrong2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_Expectlist_Vehiclesstrong2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "ms") return ms_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "da") return da_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "de") return de_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "en-US") return en_us2_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "fil") return fil_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "fr") return fr_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "it") return it_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "hu") return hu_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "nl") return nl_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "no") return no_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "pl") return pl_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "pt") return pt_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "ro") return ro_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "fi") return fi_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "sv") return sv_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "vi") return vi_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "tr") return tr_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "cs") return cs_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "bg") return bg_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "ru") return ru_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "uk") return uk_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "ar") return ar_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "hi") return hi_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "th") return th_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "ja") return ja_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_expectlist_vehiclesstrong2(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_expectlist_vehiclesstrong2(inputs)
	return ko_misc_posts_expectlist_vehiclesstrong2(inputs)
});
export { misc_posts_expectlist_vehiclesstrong2 as "misc.posts.expectList.vehiclesStrong" }